import type { Accessorials } from "@/Shared/types";
import type { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { accessorialFromType } from "@/Data/accessorialFromType";

export function nameAccessorials(
  accessorials: Accessorials,
  scope: LocationContext | undefined,
  locationType: LocationType | undefined,
) {
  const a = accessorials
    .map(
      (accessorialType) =>
        accessorialFromType(scope, locationType, accessorialType)?.name,
    )
    .filter((o) => o !== undefined);

  if (a.length === 0) {
    return ["None Selected"];
  }

  return a;
}
